/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleListResponse } from '../../models/role-list-response';

export interface RolesGet$Params {
  'Active-Tenant-Identifier': string;
  authorizedRoles?: boolean;

/**
 * Tenant identifier, to fetch custom roles for the tenant.
 */
  tenantId?: string;
}

export function rolesGet(http: HttpClient, rootUrl: string, params: RolesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleListResponse>> {
  const rb = new RequestBuilder(rootUrl, rolesGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('authorizedRoles', params.authorizedRoles, {});
    rb.query('tenantId', params.tenantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoleListResponse>;
    })
  );
}

rolesGet.PATH = '/roles';
